export class SearchReport {
    family : string;
	subFamily : string;
	clothes : string;
	type : string;
	nid : string;
	ref : string;
	toDate : Date;
	fromDate : Date;
	clothesId : number[]= [];
	sizes : string[]= [];
	orderId : number;
	status : string;
	closeDate : Date;
}